<template>
  <div class="timeframe-group">
    <div class="timeframe-visit-container" :class="[{ active: switchValueTimeFrameVisit }]">
      <div class="left-timeframe-visit-container">
        <div class="left-switch-timeframe-visit-container">
          <div class="switch-visit">
            <input id="s-visit" type="checkbox" class="switch" v-model="switchValueVisit" @change="buildSwitchValue('visit')" />
          </div>
          <div class="text-visit">Visit น้อยกว่า</div>
        </div>
        <div class="left-input-timeframe-visit-container">
          <div class="input-visit">
            <input
              :disabled="!switchValueVisit"
              type="text"
              v-model="formattedValueVisit"
              @input="onInput($event, 'visit')"
              @blur="formatNumberNonDigits('visit')"
              @focus="removeFormatting('visit')"
            />
          </div>
          <div class="text-input-visit">ครั้ง</div>
        </div>
      </div>
      <div class="divider" />
      <div class="right-timeframe-visit-container">
        <div class="right-top-timeframe-visit-container">
          <div class="right-switch-timeframe-visit-container">
            <div class="switch-visit">
              <input
                :disabled="!switchValueVisit"
                id="s-timeframe-visit"
                type="checkbox"
                class="switch"
                v-model="switchValueTimeFrameVisit"
                @change="buildSwitchValueTimeFrameVisit()"
              />
            </div>
            <div class="text-visit">Timeframe</div>
          </div>
          <div v-if="switchValueTimeFrameVisit" class="right-dropdown-timeframe-visit-container">
            <div class="dropdown-visit">
              <v-select
                v-model="timeframeTypeVisitSelect"
                @update:modelValue="handleSelectChange('visit')"
                :options="filteredTimeframesTypeVisit"
                :clearable="false"
                :searchable="false"
              ></v-select>
            </div>
          </div>
        </div>
        <div v-if="switchValueTimeFrameVisit && isTimesframeCustomVisit" class="right-bottom-timeframe-visit-container">
          <div class="right-text-timeframe-visit-container">
            <div class="text-visit">ย้อนหลัง</div>
          </div>
          <div class="right-after-timeframe-visit-container">
            <div class="input-visit">
              <input
                type="text"
                v-model="formattedValueTimeFrameVisit"
                @input="onInput($event, 'timeframe-visit')"
                @blur="formatNumberNonDigits('timeframe-visit')"
                @focus="removeFormatting('timeframe-visit')"
              />
            </div>
            <div class="dropdown-visit">
              <v-select v-model="timeframeVisitSelect" :options="dropDownTimeframe" :clearable="false" :searchable="false"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="operation-container">
      <div class="operation-container-wrp">
        <div class="operation-container-inner">
          <div class="vertical-line" />
          <div class="operation-condition-wrp" @click="changeOperation()">
            <div :class="['condition-wrp', 'and', operation == 'and' && ' active']">และ</div>
            <div :class="['condition-wrp', 'or', operation == 'or' && ' active']">หรือ</div>
          </div>
          <div class="vertical-line" />
        </div>
      </div>
    </div>

    <div class="timeframe-total-container" :class="[{ active: switchValueTimeFrameTotal }]">
      <div class="left-timeframe-total-container">
        <div class="left-switch-timeframe-total-container">
          <div class="switch-total">
            <input id="s-total" type="checkbox" class="switch" v-model="switchValueTotal" @change="buildSwitchValue('total')" />
          </div>
          <div class="text-total">Total Spending น้อยกว่า</div>
        </div>
        <div class="left-input-timeframe-total-container">
          <div class="input-total">
            <input
              :disabled="!switchValueTotal"
              type="text"
              v-model="formattedValueTotal"
              @input="onInput($event, 'total')"
              @blur="formatNumber('total')"
              @focus="removeFormatting('total')"
            />
          </div>
          <div class="text-input-total">บาท</div>
        </div>
      </div>
      <div class="divider" />
      <div class="right-timeframe-total-container">
        <div class="right-top-timeframe-total-container">
          <div class="right-switch-timeframe-total-container">
            <div class="switch-total">
              <input
                :disabled="!switchValueTotal"
                id="s-timeframe-total"
                type="checkbox"
                class="switch"
                v-model="switchValueTimeFrameTotal"
                @change="buildSwitchValueTimeFrameTotal()"
              />
            </div>
            <div class="text-total">Timeframe</div>
          </div>
          <div v-if="switchValueTimeFrameTotal" class="right-dropdown-timeframe-total-container">
            <div class="dropdown-total">
              <v-select
                v-model="timeframeTypeTotalSelect"
                @update:modelValue="handleSelectChange('total')"
                :options="filteredTimeframesTypeTotal"
                :clearable="false"
                :searchable="false"
              ></v-select>
            </div>
          </div>
        </div>
        <div v-if="switchValueTimeFrameTotal && isTimesframeCustomTotal" class="right-bottom-timeframe-total-container">
          <div class="right-text-timeframe-total-container">
            <div class="text-total">ย้อนหลัง</div>
          </div>
          <div class="right-after-timeframe-total-container">
            <div class="input-total">
              <input
                type="text"
                v-model="formattedValueTimeFrameTotal"
                @input="onInput($event, 'timeframe-total')"
                @blur="formatNumberNonDigits('timeframe-total')"
                @focus="removeFormatting('timeframe-total')"
              />
            </div>
            <div class="dropdown-total">
              <v-select v-model="timeframeTotalSelect" :options="dropDownTimeframe" :clearable="false" :searchable="false"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="operation-container">
      <div class="operation-container-wrp">
        <div class="operation-container-inner">
          <div class="vertical-line" />
          <div class="operation-condition-wrp" @click="changeOperation()">
            <div :class="['condition-wrp', 'and', operation == 'and' && ' active']">และ</div>
            <div :class="['condition-wrp', 'or', operation == 'or' && ' active']">หรือ</div>
          </div>
          <div class="vertical-line" />
        </div>
      </div>
    </div>

    <div class="timeframe-avg-container" :class="[{ active: switchValueTimeFrameAVG }]">
      <div class="left-timeframe-avg-container">
        <div class="left-switch-timeframe-avg-container">
          <div class="switch-avg">
            <input id="s-avg" type="checkbox" class="switch" v-model="switchValueAVG" @change="buildSwitchValue('avg')" />
          </div>
          <div class="text-avg">Average Spending น้อยกว่า</div>
        </div>
        <div class="left-input-timeframe-avg-container">
          <div class="input-avg">
            <input
              :disabled="!switchValueAVG"
              type="text"
              v-model="formattedValueAVG"
              @input="onInput($event, 'avg')"
              @blur="formatNumber('avg')"
              @focus="removeFormatting('avg')"
            />
          </div>
          <div class="text-input-avg">บาท</div>
        </div>
      </div>
      <div class="divider" />
      <div class="right-timeframe-avg-container">
        <div class="right-top-timeframe-avg-container">
          <div class="right-switch-timeframe-avg-container">
            <div class="switch-avg">
              <input
                :disabled="!switchValueAVG"
                id="s-timeframe-avg"
                type="checkbox"
                class="switch"
                v-model="switchValueTimeFrameAVG"
                @change="buildSwitchValueTimeFrameAVG()"
              />
            </div>
            <div class="text-avg">Timeframe</div>
          </div>
          <div v-if="switchValueTimeFrameAVG" class="right-dropdown-timeframe-avg-container">
            <div class="dropdown-avg">
              <v-select
                v-model="timeframeTypeAVGSelect"
                @update:modelValue="handleSelectChange('avg')"
                :options="filteredTimeframesTypeAVG"
                :clearable="false"
                :searchable="false"
              ></v-select>
            </div>
          </div>
        </div>
        <div v-if="switchValueTimeFrameAVG && isTimesframeCustomAVG" class="right-bottom-timeframe-avg-container">
          <div class="right-text-timeframe-avg-container">
            <div class="text-avg">ย้อนหลัง</div>
          </div>
          <div class="right-after-timeframe-avg-container">
            <div class="input-avg">
              <input
                type="text"
                v-model="formattedValueTimeFrameAVG"
                @input="onInput($event, 'timeframe-avg')"
                @blur="formatNumberNonDigits('timeframe-avg')"
                @focus="removeFormatting('timeframe-avg')"
              />
            </div>
            <div class="dropdown-avg">
              <v-select v-model="timeframeAVGSelect" :options="dropDownTimeframe" :clearable="false" :searchable="false"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw, computed } from 'vue';

const operation: Ref<string> = ref('and');
const switchValueVisit: Ref<boolean> = ref(false);
const switchValueTotal: Ref<boolean> = ref(false);
const switchValueAVG: Ref<boolean> = ref(false);
const switchValueTimeFrameVisit: Ref<boolean> = ref(false);
const switchValueTimeFrameTotal: Ref<boolean> = ref(false);
const switchValueTimeFrameAVG: Ref<boolean> = ref(false);

const valueVisit = ref<number | null>(null);
const formattedValueVisit = ref<string>('');
const valueTotal = ref<number | null>(null);
const formattedValueTotal = ref<string>('');
const valueAVG = ref<number | null>(null);
const formattedValueAVG = ref<string>('');
const valueTimeFrameVisit = ref<number | null>(null);
const formattedValueTimeFrameVisit = ref<string>('');
const valueTimeFrameTotal = ref<number | null>(null);
const formattedValueTimeFrameTotal = ref<string>('');
const valueTimeFrameAVG = ref<number | null>(null);
const formattedValueTimeFrameAVG = ref<string>('');

const dropDownTimeframe = ref<any[]>([
  { label: 'วัน', id: 0 },
  { label: 'เดือน', id: 1 },
  { label: 'ปี', id: 2 },
]);
const dropDownTimeframeType = ref<any[]>([
  { label: 'กำหนดค่าเอง', value: 'custom', active: true },
  { label: 'ค่าเดียวกับ Visit', value: 'visit', active: false },
  { label: 'ค่าเดียวกับ Total Spending', value: 'total', active: false },
  { label: 'ค่าเดียวกับ Average Spending', value: 'avg', active: false },
]);

// ค่าที่ใช้ใน v-select
const filteredTimeframesTypeVisit = computed(() => filterOptions('visit'));
const filteredTimeframesTypeTotal = computed(() => filterOptions('total'));
const filteredTimeframesTypeAVG = computed(() => filterOptions('avg'));

const timeframeTypeVisitSelect = ref<any>({ label: 'กำหนดค่าเอง', value: 'custom', active: true });
const timeframeTypeTotalSelect = ref<any>({ label: 'กำหนดค่าเอง', value: 'custom', active: true });
const timeframeTypeAVGSelect = ref<any>({ label: 'กำหนดค่าเอง', value: 'custom', active: true });

const isTimesframeCustomVisit: Ref<boolean> = ref(true);
const isTimesframeCustomTotal: Ref<boolean> = ref(true);
const isTimesframeCustomAVG: Ref<boolean> = ref(true);

const timeframeVisitSelect = ref<any>({ label: 'วัน', id: 0 });
const timeframeTotalSelect = ref<any>({ label: 'วัน', id: 0 });
const timeframeAVGSelect = ref<any>({ label: 'วัน', id: 0 });

// ฟังก์ชันกรอง (สามารถเปลี่ยนเงื่อนไขตามต้องการ)
function filterOptions(type: string) {
  // ตัวอย่างกรองข้อมูล: เลือกเฉพาะ options ที่มี value ไม่เป็น '7d'
  return dropDownTimeframeType.value.filter((option: any) => option.active == true && option.value != type);
}

function handleSelectChange(type: string) {
  // timeframeTypeVisitSelect
  switch (type) {
    case 'visit':
      if (timeframeTypeVisitSelect.value.value != 'custom') {
        isTimesframeCustomVisit.value = false;
      } else {
        isTimesframeCustomVisit.value = true;
      }

      break;
    case 'total':
      if (timeframeTypeTotalSelect.value.value != 'custom') {
        isTimesframeCustomTotal.value = false;
      } else {
        isTimesframeCustomTotal.value = true;
      }

      break;
    case 'avg':
      if (timeframeTypeAVGSelect.value.value != 'custom') {
        isTimesframeCustomAVG.value = false;
      } else {
        isTimesframeCustomAVG.value = true;
      }
      break;
    default:
      break;
  }
}

function formatNumber(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueVisit.value);
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTotal.value);
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueAVG.value);
      }
      break;
    case 'timeframe-visit':
      if (valueTimeFrameVisit.value !== null) {
        formattedValueTimeFrameVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTimeFrameVisit.value);
      }
      break;
    case 'timeframe-total':
      if (valueTimeFrameTotal.value !== null) {
        formattedValueTimeFrameTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTimeFrameTotal.value);
      }
      break;
    case 'timeframe-avg':
      if (valueTimeFrameAVG.value !== null) {
        formattedValueTimeFrameAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valueTimeFrameAVG.value);
      }
      break;
    default:
      break;
  }
}
function formatNumberNonDigits(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueVisit.value);
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTotal.value);
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueAVG.value);
      }
      break;
    case 'timeframe-visit':
      if (valueTimeFrameVisit.value !== null) {
        formattedValueTimeFrameVisit.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTimeFrameVisit.value);
      }
      break;
    case 'timeframe-total':
      if (valueTimeFrameTotal.value !== null) {
        formattedValueTimeFrameTotal.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTimeFrameTotal.value);
      }
      break;
    case 'timeframe-avg':
      if (valueTimeFrameAVG.value !== null) {
        formattedValueTimeFrameAVG.value = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(valueTimeFrameAVG.value);
      }
      break;
    default:
      break;
  }
}
function removeFormatting(type: string) {
  switch (type) {
    case 'visit':
      if (valueVisit.value !== null) {
        formattedValueVisit.value = valueVisit.value.toString();
      }
      break;
    case 'total':
      if (valueTotal.value !== null) {
        formattedValueTotal.value = valueTotal.value.toString();
      }
      break;
    case 'avg':
      if (valueAVG.value !== null) {
        formattedValueAVG.value = valueAVG.value.toString();
      }
      break;
    case 'timeframe-visit':
      if (valueTimeFrameVisit.value !== null) {
        formattedValueTimeFrameVisit.value = valueTimeFrameVisit.value.toString();
      }
      break;
    case 'timeframe-total':
      if (valueTimeFrameTotal.value !== null) {
        formattedValueTimeFrameTotal.value = valueTimeFrameTotal.value.toString();
      }
      break;
    case 'timeframe-avg':
      if (valueTimeFrameAVG.value !== null) {
        formattedValueTimeFrameAVG.value = valueTimeFrameAVG.value.toString();
      }
      break;
    default:
      break;
  }
}

function onInput(event: Event, type: string) {
  const input = event.target as HTMLInputElement;
  let rawValue = input.value.replace(/,/g, '');

  // Remove any non-numeric characters except for the decimal point
  rawValue = rawValue.replace(/[^0-9.]/g, '');

  // Handle multiple decimal points by allowing only the first one
  const decimalIndex = rawValue.indexOf('.');
  if (decimalIndex !== -1) {
    rawValue = rawValue.slice(0, decimalIndex + 1) + rawValue.slice(decimalIndex + 1).replace(/\./g, '');
  }

  switch (type) {
    case 'visit':
      if (!isNaN(parseFloat(rawValue))) {
        valueVisit.value = parseFloat(rawValue);
        formattedValueVisit.value = rawValue;
      } else {
        formattedValueVisit.value = '';
      }
      break;
    case 'total':
      if (!isNaN(parseFloat(rawValue))) {
        valueTotal.value = parseFloat(rawValue);
        formattedValueTotal.value = rawValue;
      } else {
        formattedValueTotal.value = '';
      }
      break;
    case 'avg':
      if (!isNaN(parseFloat(rawValue))) {
        valueAVG.value = parseFloat(rawValue);
        formattedValueAVG.value = rawValue;
      } else {
        formattedValueAVG.value = '';
      }
      break;
    case 'timeframe-visit':
      if (!isNaN(parseFloat(rawValue))) {
        valueTimeFrameVisit.value = parseFloat(rawValue);
        formattedValueTimeFrameVisit.value = rawValue;
      } else {
        formattedValueTimeFrameVisit.value = '';
      }
      break;
    case 'timeframe-total':
      if (!isNaN(parseFloat(rawValue))) {
        valueTimeFrameTotal.value = parseFloat(rawValue);
        formattedValueTimeFrameTotal.value = rawValue;
      } else {
        formattedValueTimeFrameTotal.value = '';
      }
      break;
    case 'timeframe-avg':
      if (!isNaN(parseFloat(rawValue))) {
        valueTimeFrameAVG.value = parseFloat(rawValue);
        formattedValueTimeFrameAVG.value = rawValue;
      } else {
        formattedValueTimeFrameAVG.value = '';
      }
      break;
    default:
      break;
  }
}

function buildSwitchValue(type: string) {
  let timeframeType = dropDownTimeframeType.value.find((el: any) => el.value == type);

  if (!timeframeType) return;

  switch (type) {
    case 'visit':
      if (switchValueVisit.value == false) {
        switchValueTimeFrameVisit.value = false;
        formattedValueVisit.value = '';
        valueVisit.value = null;
        timeframeType.active = false;
      } else {
        timeframeType.active = true;
      }
      buildSwitchValueTimeFrameVisit();
      break;
    case 'total':
      if (switchValueTotal.value == false) {
        switchValueTimeFrameTotal.value = false;
        formattedValueTotal.value = '';
        valueTotal.value = null;
        timeframeType.active = false;
      } else {
        timeframeType.active = true;
      }
      buildSwitchValueTimeFrameTotal();
      break;
    case 'avg':
      if (switchValueAVG.value == false) {
        switchValueTimeFrameAVG.value = false;
        formattedValueAVG.value = '';
        valueAVG.value = null;
        timeframeType.active = false;
      } else {
        timeframeType.active = true;
      }
      buildSwitchValueTimeFrameAVG();
      break;
    default:
      break;
  }
}

function buildSwitchValueTimeFrameVisit() {
  //switchValueTimeFrameVisit
  if (!switchValueTimeFrameVisit.value) {
    // check visit
    if (timeframeTypeTotalSelect.value.value == 'visit') {
      // timeframeTypeTotalSelect
      timeframeTypeTotalSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomTotal.value = true;
    }
    if (timeframeTypeAVGSelect.value.value == 'visit') {
      // timeframeTypeAVGSelect
      timeframeTypeAVGSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomAVG.value = true;
    }
  }
}
function buildSwitchValueTimeFrameTotal() {
  //switchValueTimeFrameTotal
  if (!switchValueTimeFrameTotal.value) {
    // check total

    if (timeframeTypeVisitSelect.value.value == 'total') {
      // timeframeTypeVisitSelect
      timeframeTypeVisitSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomVisit.value = true;
    }
    if (timeframeTypeAVGSelect.value.value == 'total') {
      // timeframeTypeAVGSelect
      timeframeTypeAVGSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomAVG.value = true;
    }
  }
}
function buildSwitchValueTimeFrameAVG() {
  //switchValueTimeFrameAVG
  if (!switchValueTimeFrameAVG.value) {
    // check avg
    if (timeframeTypeVisitSelect.value.value == 'avg') {
      // timeframeTypeVisitSelect
      timeframeTypeVisitSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomVisit.value = true;
    }
    if (timeframeTypeTotalSelect.value.value == 'avg') {
      // timeframeTypeTotalSelect
      timeframeTypeTotalSelect.value = { label: 'กำหนดค่าเอง', value: 'custom', active: true };
      isTimesframeCustomTotal.value = true;
    }
  }
}

function changeOperation() {
  switch (operation.value) {
    case 'and':
      operation.value = 'or';
      break;
    case 'or':
      operation.value = 'and';
      break;
  }
}

// format the number when the component is mounted
// formatNumber();
</script>

<style lang="scss" scoped>
.right-dropdown-timeframe-visit-container,
.right-dropdown-timeframe-total-container,
.right-dropdown-timeframe-avg-container {
  display: flex; /* ใช้ flexbox เพื่อให้ dropdown อยู่ในบรรทัดเดียวกัน */
  align-items: center; /* จัดแนว dropdown ให้อยู่ตรงกลางในแนวตั้ง */

  .dropdown-visit,
  .dropdown-total,
  .dropdown-avg {
    flex: 1; /* ให้แต่ละ dropdown มีขนาดเท่ากัน, หรือปรับตามความต้องการ */
    font-family: Prompt;
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    text-align: left;
    color: #2d2d2d;
    width: 100px;
    background-color: #fff;
    background-clip: padding-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    letter-spacing: 0.031rem;
    margin: auto auto auto 0;
    border-radius: 10px;

    &:deep(.vs__dropdown-toggle) {
      border: 1px solid #e2e2e2;
      border-radius: 10px;
      height: 42px;
    }

    .vs__selected-options {
      position: relative;
      height: 100%;
      flex-wrap: nowrap;
      max-width: calc(100% - 25px);
    }

    .v-select {
      width: 100%;

      .vs__dropdown-toggle {
        height: 100%;

        .vs__selected {
          position: absolute;
          height: 100%;
          margin: auto auto auto 0;
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 100%;
          overflow: hidden;
        }
      }
    }
  }
}
.right-after-timeframe-visit-container,
.right-after-timeframe-total-container,
.right-after-timeframe-avg-container {
  display: flex; /* ใช้ flexbox เพื่อให้ dropdown อยู่ในบรรทัดเดียวกัน */
  align-items: center; /* จัดแนว dropdown ให้อยู่ตรงกลางในแนวตั้ง */

  .dropdown-visit,
  .dropdown-total,
  .dropdown-avg {
    flex: 1; /* ให้แต่ละ dropdown มีขนาดเท่ากัน, หรือปรับตามความต้องการ */
    font-family: Prompt;
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    text-align: left;
    color: #2d2d2d;
    width: 100px;
    background-color: #fff;
    background-clip: padding-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    letter-spacing: 0.031rem;
    margin: auto auto auto 0;
    border-radius: 10px;

    &:deep(.vs__dropdown-toggle) {
      border: 1px solid #e2e2e2;
      border-radius: 10px;
      height: 42px;
    }

    .vs__selected-options {
      position: relative;
      height: 100%;
      flex-wrap: nowrap;
      max-width: calc(100% - 25px);
    }

    .v-select {
      width: 100%;

      .vs__dropdown-toggle {
        height: 100%;

        .vs__selected {
          position: absolute;
          height: 100%;
          margin: auto auto auto 0;
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 100%;
          overflow: hidden;
        }
      }
    }
  }
}

input {
  //styleName: Text Reg 16;
  font-family: Prompt;
  font-size: 16px;
  font-weight: 400;
  line-height: 24.19px;
  text-align: left;

  color: #2d2d2d;
  margin: 0;
  display: block;
  width: 100px;
  padding: 8px 16px 8px 16px;
  line-height: 1;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e2e2e2;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 10px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  letter-spacing: 0.031rem;
  &:focus {
    outline: 0px solid transparent;
  }
  &:disabled {
    background-color: #f0f0f0;
    color: #a0a0a0;
    cursor: not-allowed;
    border: 1px solid #ccc;
  }
}
//
input[type='checkbox'].switch {
  --active: #6bb84c;
  --active-inner: #fff;
  --focus: 2px #6bb84c30;
  --border: rgba(0, 0, 0, 0.25);
  --border-hover: #6bb84c;
  --background: #fff;
  --disabled: #f6f8ff;
  --disabled-inner: #e1e6f9;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 21px;
  outline: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin: 0;
  cursor: pointer;
  border: 1px solid var(--bc, var(--border));
  background: var(--b, var(--background));
  transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
  &:after {
    content: '';
    display: block;
    left: 0;
    top: 0;
    position: absolute;
    transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
  }
  &:checked {
    --b: var(--active);
    --bc: var(--active);
    --d-o: 0.3s;
    --d-t: 0.6s;
    --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
  }
  &:disabled {
    --b: var(--disabled);
    cursor: not-allowed;
    opacity: 0.9;
    &:checked {
      --b: var(--disabled-inner);
      --bc: var(--border);
    }
    & + label {
      cursor: not-allowed;
    }
  }
  &:hover {
    &:not(:checked) {
      &:not(:disabled) {
        --bc: var(--border-hover);
      }
    }
  }
  &:focus {
    box-shadow: 0 0 0 var(--focus);
  }
  & + label {
    font-size: 14px;
    line-height: 21px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: 4px;
  }
}
input[type='checkbox'].switch {
  width: 38px;
  border-radius: 11px;
  &:after {
    left: 2px;
    top: 2px;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background: var(--ab, var(--border));
    transform: translateX(var(--x, 0));
  }
  &:checked {
    --ab: var(--active-inner);
    --x: 17px;
  }
  &:disabled {
    &:not(:checked) {
      &:after {
        opacity: 0.6;
      }
    }
  }
}
.timeframe-group {
  margin-top: 2rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  .timeframe-visit-container {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 26px;
    gap: 56px;
    border-radius: 10px;
    border: 1px solid rgba(226, 226, 226, 1);
    height: 90px;
    &.active {
      height: 150px;
    }
    .left-timeframe-visit-container {
      width: 50%;
      display: flex;
      justify-content: space-between;
      .left-switch-timeframe-visit-container {
        display: flex;
        align-items: center;
        .switch-visit {
        }
        .text-visit {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
      .left-input-timeframe-visit-container {
        display: flex;
        align-items: center;
        .input-visit {
        }
        .text-input-visit {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
    }
    .divider {
      margin-left: 2rem;
      margin-right: 2rem;
      width: 1px;
      height: 95%;
      background: #e2e2e2;
    }
    .right-timeframe-visit-container {
      width: 50%;
      display: flex;
      flex-direction: column;
      .right-top-timeframe-visit-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right-switch-timeframe-visit-container {
          display: flex;
          .switch-visit {
          }
          .text-visit {
            margin-left: 1.5rem;
            //styleName: Text Med 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 500;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-dropdown-timeframe-visit-container {
          display: flex;
          width: 300px;
          .dropdown-visit {
            display: flex;
            width: 100%;
          }
        }
      }
      .right-bottom-timeframe-visit-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;
        .right-text-timeframe-visit-container {
          display: flex;
          .text-visit {
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-after-timeframe-visit-container {
          display: flex;
          align-items: center;
          .input-visit {
          }
          .dropdown-visit {
            margin-left: 1.5rem;
          }
        }
      }
    }
  }

  .operation-container {
    .operation-container-wrp {
      position: relative;
      width: 100%;
      padding: 0 50px;
      display: flex;
      justify-content: start;

      .operation-container-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .operation-condition-wrp {
          width: 90px;
          height: 50px;
          background-color: #fff;
          border-radius: 4px;
          display: flex;
          align-items: center;
          box-shadow: 0px 3px 5px 3px #80808017;

          .condition-wrp {
            width: 35px;
            height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #76767610;
            color: #767676;
            border-radius: 4px;
            margin: auto;
            cursor: pointer;

            &.active {
              color: #fff;

              &.and {
                background-color: #009dff;
              }

              &.or {
                background-color: #ff7f00;
              }
            }
          }

          // prevent text hightlight
          -webkit-user-select: none; /* Safari /
      -ms-user-select: none; / IE 10 and IE 11 /
      user-select: none; / Standard syntax */
        }
      }

      .vertical-line {
        height: 30px;
        width: 1px;
        background-color: #767676;
      }
    }
  }

  .timeframe-total-container {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 26px;
    gap: 56px;
    border-radius: 10px;
    border: 1px solid rgba(226, 226, 226, 1);
    height: 90px;
    &.active {
      height: 150px;
    }
    .left-timeframe-total-container {
      width: 50%;
      display: flex;
      justify-content: space-between;
      .left-switch-timeframe-total-container {
        display: flex;
        align-items: center;
        .switch-total {
        }
        .text-total {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
      .left-input-timeframe-total-container {
        display: flex;
        align-items: center;
        .input-total {
        }
        .text-input-total {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
    }
    .divider {
      margin-left: 2rem;
      margin-right: 2rem;
      width: 1px;
      height: 95%;
      background: #e2e2e2;
    }
    .right-timeframe-total-container {
      width: 50%;
      display: flex;
      flex-direction: column;
      .right-top-timeframe-total-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right-switch-timeframe-total-container {
          display: flex;
          .switch-total {
          }
          .text-total {
            margin-left: 1.5rem;
            //styleName: Text Med 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 500;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-dropdown-timeframe-total-container {
          display: flex;
          width: 300px;
          .dropdown-total {
            display: flex;
            width: 100%;
          }
        }
      }
      .right-bottom-timeframe-total-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;
        .right-text-timeframe-total-container {
          display: flex;
          .text-total {
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-after-timeframe-total-container {
          display: flex;
          align-items: center;
          .input-total {
          }
          .dropdown-total {
            margin-left: 1.5rem;
          }
        }
      }
    }
  }

  .timeframe-avg-container {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 26px;
    gap: 56px;
    border-radius: 10px;
    border: 1px solid rgba(226, 226, 226, 1);
    height: 90px;
    &.active {
      height: 150px;
    }
    .left-timeframe-avg-container {
      width: 50%;
      display: flex;
      justify-content: space-between;
      .left-switch-timeframe-avg-container {
        display: flex;
        align-items: center;
        .switch-avg {
        }
        .text-avg {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
      .left-input-timeframe-avg-container {
        display: flex;
        align-items: center;
        .input-avg {
        }
        .text-input-avg {
          margin-left: 1.5rem;
          //styleName: Text Reg 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
        }
      }
    }
    .divider {
      margin-left: 2rem;
      margin-right: 2rem;
      width: 1px;
      height: 95%;
      background: #e2e2e2;
    }
    .right-timeframe-avg-container {
      width: 50%;
      display: flex;
      flex-direction: column;
      .right-top-timeframe-avg-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right-switch-timeframe-avg-container {
          display: flex;
          .switch-avg {
          }
          .text-avg {
            margin-left: 1.5rem;
            //styleName: Text Med 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 500;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-dropdown-timeframe-avg-container {
          display: flex;
          width: 300px;
          .dropdown-avg {
            display: flex;
            width: 100%;
          }
        }
      }
      .right-bottom-timeframe-avg-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;
        .right-text-timeframe-avg-container {
          display: flex;
          .text-avg {
            //styleName: Text Reg 16;
            font-family: Prompt;
            font-size: 16px;
            font-weight: 400;
            line-height: 24.19px;
            text-align: left;
          }
        }
        .right-after-timeframe-avg-container {
          display: flex;
          align-items: center;
          .input-avg {
          }
          .dropdown-avg {
            margin-left: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
